import React, { useState, useEffect } from "react";
import {
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  NavLink,
} from "reactstrap";
import { BsTable } from "react-icons/bs";
import { IoDocumentOutline } from "react-icons/io5";
import { IoPrintOutline } from "react-icons/io5";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";
import { Autocomplete, Chip, TextField } from "@mui/material";
import Select from "react-select";
import { useSelector } from "react-redux";
import Dropdown from "react-bootstrap/Dropdown";
import { MultiSelect } from "react-multi-select-component";
import html2pdf from "html2pdf.js";
import { toast } from "react-toastify";

const ReportTemplates = (props) => {
  const {
    pdfExportComponent,
    ColumnArr,
    selectedValues,
    setSelectedValues,
    setFontSizeVal,
    fontSizeVal,
    setPaperSizeVal,
    paperSizeVal,
    setLayoutVal,
    layoutVal,
    setScalePDF,
    scalePDF,
    setMarginPDF,
    marginPDF,
    setScreenSizePerPdf,
    screenSizePerPdf,
    setDimensionOfPages,
    trialBalance = "",
    contentRef = "",
    fileName = "",
    setCount = "",
    setExpandAll = "",
    setlevelCheck = "",
    count = "",
    setLoadingDownloadFile = "",
    printExcel = () => {},
    printTXT = () => {},
    printpdf = () => {},
  } = props;

  const HeadingArr = [
    {
      label: "Report Heading 1",
      value: "Report Heading 1",
    },
    {
      label: "Report Heading 2",
      value: "Report Heading 2",
    },
    {
      label: "Report Heading 3",
      value: "Report Heading 3",
    },
    {
      label: "Report Heading 4",
      value: "Report Heading 4",
    },
    {
      label: "Report Heading 5",
      value: "Report Heading 5",
    },
    {
      label: "Report Heading 6",
      value: "Report Heading 6",
    },
    {
      label: "Report Heading 7",
      value: "Report Heading 7",
    },
    {
      label: "Report Heading 8",
      value: "Report Heading 8",
    },
  ];
  const SubHeadingArr = [
    {
      label: "Sub Heading 1",
      value: "Sub Heading 1",
    },
    {
      label: "Sub Heading 2",
      value: "Sub Heading 2",
    },
    {
      label: "Sub Heading 3",
      value: "Sub Heading 3",
    },
    {
      label: "Sub Heading 4",
      value: "Sub Heading 4",
    },
    {
      label: "Sub Heading 5",
      value: "Sub Heading 5",
    },
    {
      label: "Sub Heading 6",
      value: "Sub Heading 6",
    },
    {
      label: "Sub Heading 7",
      value: "Sub Heading 7",
    },
    {
      label: "Sub Heading 8",
      value: "Sub Heading 8",
    },
  ];

  const dimensionForPages = [
    { key: "Letter", dimensions: ["816px", "1056px"] },
    { key: "Legal", dimensions: ["816px", "1344px"] },
    { key: "A4", dimensions: ["794px", "1123px"] },
    { key: "A5", dimensions: ["559px", "794px"] },
    { key: "B5", dimensions: ["665px", "945px"] },
    // { key: 'Executive', dimensions: ["7.25", "10.5"] },
    { key: "Tabloid", dimensions: ["1056px", "1632px"] },
    { key: "A3", dimensions: ["1123px", "1587px"] },
    { key: "A6", dimensions: ["397px", "559px"] },
    { key: "C5", dimensions: ["612px", "866px"] },
    { key: "C6", dimensions: ["431px", "612px"] },
  ];
  // const dimensionForPages =
  //     [
  //         { key: 'Letter', dimensions: ["8.5", "11.0"] },
  //         { key: 'Legal', dimensions: ["8.5", "14.0"] },
  //         { key: 'A4', dimensions: ["8.3", "11.7"] },
  //         { key: 'A5', dimensions: ["5.8", "8.3"] },
  //         { key: 'B5', dimensions: ["6.9", "9.8"] },
  //         // { key: 'Executive', dimensions: ["7.25", "10.5"] },
  //         { key: 'Tabloid', dimensions: ["11", "17"] },
  //         { key: 'A3', dimensions: ["11.7", "16.5"] },
  //         { key: 'A6', dimensions: ["4.1", "5.8"] },
  //         { key: 'C5', dimensions: ["6.4", "9"] },
  //         { key: 'C6', dimensions: ["4.5", "6.4"] }
  //     ]
  const [BalanceArr, setBalanceArr] = useState([
    {
      label: "Opening Balance",
      value: "Opening Balance",
    },
    {
      label: "Closing Balance",
      value: "Closing Balance",
    },
  ]);

  const paperSizesArr = [
    "Letter",
    "Legal",
    "A4",
    "A5",
    "B5",
    // "Executive",
    "Tabloid",
    "A3",
    "A6",
    "C5",
    "C6",
  ];

  useEffect(() => {
    if (trialBalance && trialBalance?.length > 0) {
      setBalanceArr(
        selectedValues?.columns
          ?.map((ele) => {
            return [
              ele.includes("Opening Balance")
                ? {
                    label: "Opening Balance Debit",
                    value: "Opening Balance Debit",
                  }
                : null,
              ele.includes("Opening Balance")
                ? {
                    label: "Opening Balance Credit",
                    value: "Opening Balance Credit",
                  }
                : null,
              ele.includes("For The Period Balance")
                ? {
                    label: "Period Balance Debit",
                    value: "Period Balance Debit",
                  }
                : null,
              ele.includes("For The Period Balance")
                ? {
                    label: "Period Balance Credit",
                    value: "Period Balance Credit",
                  }
                : null,
              ele.includes("Closing Balance")
                ? {
                    label: "Closing Balance Debit",
                    value: "Closing Balance Debit",
                  }
                : null,
              ele.includes("Closing Balance")
                ? {
                    label: "Closing Balance Credit",
                    value: "Closing Balance Credit",
                  }
                : null,
            ].filter(Boolean);
          })
          ?.flat(1),
      );
    }
  }, [trialBalance, selectedValues?.columns]);

  const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);
  const [showReport, setShowReport] = useState(false);
  const [laodingPdf, setLaodingPdf] = useState(false);
  const [screen, setScreen] = useState<any>();

  const [writingStyle, setWritingStyle] = useState({
    bold: false,
    italic: false,
    underline: false,
  });
  const [searchPaperSize, setSearchPaperSize] = useState(paperSizesArr);
  const [printAll, setPrintAll] = useState(false);
  const [selectedFont, setSelectedFont] = useState<any>();

  useEffect(() => {
    setDimensionOfPages(dimensionForPages);
  }, []);

  useEffect(() => {
    const handleScreenResize = () => {
      setScreen(window?.outerWidth);
    };

    window.addEventListener("resize", handleScreenResize);
    handleScreenResize();

    return () => {
      window.removeEventListener("resize", handleScreenResize);
    };
  }, []);

  useEffect(() => {
    if (
      layoutVal?.toLowerCase() == "landscape"
      // && (paperSizeVal == "C6" || paperSizeVal == "A6")
    ) {
      if (paperSizeVal == "C6" || paperSizeVal == "A6") {
        setMarginPDF("0.4cm");
        setScalePDF(0.4);
      }

      setScreenSizePerPdf(
        paperSizeVal == "A4"
          ? 135
          : paperSizeVal == "A5"
            ? 129
            : paperSizeVal == "Tabloid" || paperSizeVal == "A3"
              ? 108
              : paperSizeVal == "A6"
                ? 169
                : paperSizeVal == "C5"
                  ? 173
                  : paperSizeVal == "C6"
                    ? 170
                    : 130,
      );
    } else if (layoutVal?.toLowerCase() == "portrait") {
      setMarginPDF(
        paperSizeVal == "A5" ||
          paperSizeVal == "A6" ||
          paperSizeVal == "C5" ||
          paperSizeVal == "C6"
          ? "0.3cm"
          : "1cm",
      );
      setScalePDF(
        paperSizeVal == "A5" || paperSizeVal == "A5"
          ? 0.4
          : paperSizeVal == "A6" || paperSizeVal == "C6"
            ? 0.3
            : 0.5,
      );

      setScreenSizePerPdf(
        paperSizeVal == "A4"
          ? 129
          : paperSizeVal == "A5"
            ? 173
            : paperSizeVal == "A3"
              ? 135
              : paperSizeVal == "A6"
                ? 228
                : paperSizeVal == "C5"
                  ? 138
                  : paperSizeVal == "C6"
                    ? 230
                    : 130,
      );
    } else {
      setMarginPDF("1cm");
      setScalePDF(0.5);
      setScreenSizePerPdf();
    }
  }, [layoutVal, paperSizeVal]);

  const handleUpdate = (key, value) => {
    setSelectedValues((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handlePrint = () => {
    // if (pdfExportComponent.current) {
    //     pdfExportComponent.current.save();
    // }
    // setTimeout(() => {
    //     setPrintAll(false)
    // }, 3000);
  };

  const customStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      background: isFocused
        ? "hsla(291, 64%, 42%, 0.5)"
        : isSelected
          ? "hsla(291, 64%, 42%, 1)"
          : undefined,
      zIndex: 1,
    }),
    menuList: (styles) => ({
      ...styles,
      background: theme == "dark" ? "#3b3b3b" : "#ffffff",
      color: theme == "dark" ? "white" : "",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 100,
    }),
    control: (base, state) => ({
      ...base,
      background: theme == "dark" ? "#25273a" : "#f2f2f2",
      borderRadius: "0.4285rem",
      borderColor: state.isFocused
        ? "#1d8cf8"
        : theme !== "light"
          ? "#2b3553"
          : "",
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        borderColor: state.isFocused ? "" : "#ba54f5",
      },
      '& .react-select__input input[type="color"]': {
        color: theme === "dark" ? "red" : "black",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: theme == "dark" ? "white" : "black",
    }),
    input: (base) => ({
      ...base,
      color: theme == "dark" ? "white" : "black",
    }),
  };

  return (
    <Col className="my-2">
      <div className="d-flex flex-column gap-3">
        {/* --------------- first row header starts from here ------------------------------- */}
        <div className="col-md-12 col-sm-12 col-12">
          <div className="d-flex flex-wrap align-items-center">
            {/* <div className='col-lg-3 col-md-3 col-sm-12 col-12 px-2 mb-2'>
                            <label className='text-start fw-bold w-100 mb-1'>Select Heading</label>
                            <Select
                                className='text-start'
                                value={selectedValues?.heading && HeadingArr?.find((item) => item?.value == selectedValues?.heading)}
                                label="Select Heading"
                                onChange={(e) => {
                                    setShowReport(false)
                                    if (e?.value) {
                                        handleUpdate("heading", e?.value)
                                    }
                                    else {
                                        handleUpdate("heading", "")
                                    }
                                }}
                                menuPortalTarget={document.body}
                                menuShouldBlockScroll={true}
                                isClearable={true}
                                isSearchable={true}
                                options={HeadingArr}
                                styles={customStyles}
                            />
                        </div>
                        <div className='col-lg-3 col-md-3 col-sm-12 col-12 px-2 mb-2'>
                            <label className='text-start fw-bold w-100 mb-1'>Select Sub-Heading</label>
                            <Select
                                className='text-start'
                                value={selectedValues?.sub_heading && SubHeadingArr?.find((item) => item?.value == selectedValues?.sub_heading)}
                                onChange={(e) => {
                                    setShowReport(false)
                                    if (e?.value) {
                                        handleUpdate("sub_heading", e?.value)
                                    }
                                    else {
                                        handleUpdate("sub_heading", "")
                                    }

                                    // setSelectedSubHeading("sub_heading",e?.value);
                                }}
                                menuPortalTarget={document.body}
                                menuShouldBlockScroll={true}
                                isClearable={true}
                                isSearchable={true}
                                options={SubHeadingArr}
                                styles={customStyles}
                            />
                        </div> */}
            <div className="col-lg-3 col-md-3 col-sm-12 col-12 px-2 mb-2">
              <label className="text-start fw-bold w-100 mb-1">
                Select Columns
              </label>
              <MultiSelect
                options={ColumnArr}
                value={ColumnArr.filter((option) =>
                  selectedValues?.columns?.includes(option.label),
                )}
                onChange={(selectedOptions) => {
                  setShowReport(false);
                  const newValue = selectedOptions.map(
                    (option) => option.label,
                  );
                  if (trialBalance && trialBalance?.length > 0) {
                    // if (!newValue.includes("Opening Balance") || !newValue.includes("Closing Balance") || !newValue.includes("For The Period Balance")) {
                    setSelectedValues((prev) => ({
                      ...prev,
                      balance: [
                        newValue.includes("Opening Balance")
                          ? "Opening Balance Debit"
                          : null,
                        newValue.includes("Opening Balance")
                          ? "Opening Balance Credit"
                          : null,
                        newValue.includes("For The Period Balance")
                          ? "Period Balance Debit"
                          : null,
                        newValue.includes("For The Period Balance")
                          ? "Period Balance Credit"
                          : null,
                        newValue.includes("Closing Balance")
                          ? "Closing Balance Debit"
                          : null,
                        newValue.includes("Closing Balance")
                          ? "Closing Balance Credit"
                          : null,
                      ].filter(Boolean),
                      columns: newValue,
                    }));
                    // }
                    // else if (!newValue.includes("Closing Balance") && !newValue.includes("For The Period Balance") && !newValue.includes("Opening Balance")) {
                    //     setSelectedValues((prev) => ({
                    //         ...prev,
                    //         balance: [],
                    //         columns: newValue
                    //     }));
                    // }
                    // else {
                    //     setSelectedValues((prev) => ({
                    //         ...prev,
                    //         columns: newValue
                    //     }));
                    // }
                  } else {
                    if (!newValue.includes("Balance")) {
                      setSelectedValues((prev) => ({
                        ...prev,
                        balance: [],
                        columns: newValue,
                      }));
                    } else {
                      setSelectedValues((prev) => ({
                        ...prev,
                        columns: newValue,
                      }));
                    }
                  }
                }}
                labelledBy={"Select Columns"}
                className={`multi-select reportTxn-multi-select-${theme}`}
                overrideStrings={{
                  selectAll: "Select all Columns",
                  selectSomeItems: "Select Columns",
                }}
              />
              {/* <Select
                                isMulti
                                options={ColumnArr}
                                value={ColumnArr.filter(option => selectedValues?.columns?.includes(option.value))}
                                onChange={(selectedOptions) => {
                                    setShowReport(false);
                                    const newValue = selectedOptions?.map(option => option?.value);

                                    if (!newValue.includes("Balance")) {
                                        setSelectedValues((prev) => ({
                                            ...prev,
                                            balance: [],
                                            columns: newValue
                                        }));
                                    }
                                    else {
                                        setSelectedValues((prev) => ({
                                            ...prev,
                                            columns: newValue
                                        }));
                                    }
                                }}
                                styles={customStyles}
                                placeholder="Select"
                            /> */}
            </div>
            {(selectedValues?.columns?.includes("Balance") ||
              selectedValues?.columns?.includes("Opening Balance") ||
              selectedValues?.columns?.includes("For The Period Balance") ||
              selectedValues?.columns?.includes("Closing Balance")) && (
              <div className="col-lg-3 col-md-3 col-sm-12 col-12 px-2 mb-2">
                <label className="text-start fw-bold w-100 mb-1">
                  Select Balance
                </label>
                <MultiSelect
                  options={BalanceArr}
                  value={BalanceArr?.filter((option) =>
                    selectedValues?.balance?.includes(option.label),
                  )}
                  onChange={(selectedOptions) => {
                    setShowReport(false);
                    const newValue = selectedOptions?.map(
                      (option) => option?.label,
                    );
                    setSelectedValues((prev) => ({
                      ...prev,
                      balance: newValue,
                    }));
                  }}
                  labelledBy={"Select Balance"}
                  className={`multi-select reportTxn-multi-select-${theme}`}
                  overrideStrings={{
                    // selectAll: "Select all Balance",
                    selectSomeItems: "Select Balance",
                  }}
                />
                {/* <Select
                                    isMulti
                                    options={BalanceArr}
                                    value={BalanceArr?.filter(option => selectedValues?.balance?.includes(option.value))}
                                    onChange={(selectedOptions) => {
                                        setShowReport(false);
                                        const newValue = selectedOptions?.map(option => option?.value);

                                        // if (!newValue.includes("Balance")) {
                                        setSelectedValues((prev) => ({
                                            ...prev,
                                            balance: newValue
                                        }));
                                        // }
                                    }
                                    }
                                    styles={customStyles}
                                    placeholder="Select"
                                /> */}
              </div>
            )}

            <div
              className={
                selectedValues?.columns?.includes("Balance") ||
                selectedValues?.columns?.includes("Opening Balance") ||
                selectedValues?.columns?.includes("For The Period Balance") ||
                selectedValues?.columns?.includes("Closing Balance")
                  ? "col-lg-6 col-md-6 col-sm-12 col-12"
                  : "col-lg-9 col-md-9 col-sm-12 col-12"
              }
            >
              <div
                style={{
                  gap: "1rem",
                }}
                className={
                  screen <= 500
                    ? "d-flex flex-column justify-content-start flex-wrap mt-3"
                    : screen <= 932
                      ? "d-flex justify-content-end flex-wrap mt-3"
                      : "d-flex justify-content-end mt-3"
                }
              >
                <div
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Increase Font Size"
                  className={screen <= 500 ? "btn-group col-12" : "btn-group "}
                  role="group"
                  aria-label="Basic example"
                >
                  <button
                    id={`Text_Increase_${theme}`}
                    onClick={() => {
                      setFontSizeVal((prev) =>
                        Number(prev) >= 8 && Number(prev) < 12
                          ? Number(prev) + 1
                          : Number(prev) >= 12 && Number(prev) < 28
                            ? Number(prev) + 2
                            : Number(prev) >= 28 && Number(prev) < 36
                              ? Number(prev) + 8
                              : "",
                      );
                      setSelectedFont("Increase");
                    }}
                    type="button"
                    disabled={fontSizeVal == 28}
                    className={
                      selectedFont == "Increase"
                        ? "btn border btn-sm active"
                        : "btn border btn-sm"
                    }
                    style={{
                      height: "33px",
                      background: "none",
                      color:
                        theme == "light" && selectedFont == "Increase"
                          ? "white"
                          : "",
                    }}
                  >
                    {/* <img src={FontIncreaseIcon} /> */}
                    <span style={{ fontSize: "16px", position: "relative" }}>
                      A
                      <IoIosArrowUp
                        className="iconReport"
                        style={{
                          position: "absolute",
                          top: "-6px",
                          right: "-3px",
                          paddingRight: "0px",
                        }}
                      />
                    </span>
                  </button>
                  <button
                    id={`Text_Increase_${theme}`}
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Decrease Font Size"
                    style={{
                      borderLeft: screen <= 500 ? "1px solid white" : "",
                      height: "33px",
                      background: "none",
                      color:
                        theme == "light" && selectedFont == "Decrease"
                          ? "white"
                          : "",
                    }}
                    onClick={() => {
                      setFontSizeVal((prev) =>
                        Number(prev) >= 8 && Number(prev) < 12
                          ? Number(prev) - 1
                          : Number(prev) >= 12 && Number(prev) < 28
                            ? Number(prev) - 2
                            : Number(prev) >= 28 && Number(prev) <= 36
                              ? Number(prev) - 8
                              : "",
                      );
                      setSelectedFont("Decrease");
                    }}
                    type="button"
                    disabled={fontSizeVal == 8}
                    className={
                      selectedFont == "Decrease"
                        ? "btn border btn-sm active"
                        : "btn border btn-sm"
                    }
                  >
                    <span style={{ fontSize: "12px", position: "relative" }}>
                      A
                      <IoIosArrowDown
                        className="iconReport"
                        style={{
                          position: "absolute",
                          top: "-6px",
                          right: "-3px",
                          paddingRight: "0px",
                        }}
                      />
                    </span>
                  </button>
                </div>
                <div
                  // style={{ zIndex: 0 }}

                  className={
                    screen <= 500
                      ? "btn-group col-12 align-items-center"
                      : "btn-group align-items-center"
                  }
                  role="group"
                  aria-label="Basic example"
                >
                  <div
                    className={screen <= 500 ? "dropdown col-8" : "dropdown"}
                  >
                    <Dropdown className="float-right transaction_dropdown">
                      <Dropdown.Toggle
                        id="report_dropdown"
                        style={{
                          background: "none",
                          padding: "0px",
                          margin: "0px",
                        }}
                      >
                        <div
                          id={`report_paperSize_${theme}`}
                          style={{
                            cursor: "pointer",
                            width: screen <= 500 ? "" : "fit-content",
                            borderTopLeftRadius: "5px",
                            borderBottomLeftRadius: "5px",
                            borderTopRightRadius: "0px",
                            borderBottomRightRadius: "0px",
                            color: theme == "dark" ? "white" : "black",
                          }}
                          className={
                            theme == "light"
                              ? "theme_light_border d-flex px-3 border py-1 align-items-center"
                              : "d-flex px-3 border py-1 align-items-center"
                          }
                          data-bs-toggle="dropdown"
                        >
                          {paperSizeVal}
                        </div>
                      </Dropdown.Toggle>

                      <Dropdown.Menu
                        style={{
                          width: "100%",
                          maxHeight: "300px",
                          minHeight: "300px",
                          overflow: "auto",
                          backgroundColor:
                            theme == "dark" ? "rgb(30, 30, 47)" : "",
                        }}
                      >
                        {searchPaperSize?.length > 0 ? (
                          searchPaperSize?.map((item, index) => {
                            return (
                              <Dropdown.Item
                                style={{ cursor: "pointer" }}
                                onClick={() => setPaperSizeVal(item)}
                                key={index}
                                className={
                                  paperSizeVal === item
                                    ? "bg-info text-white"
                                    : ""
                                }
                              >
                                {item}
                              </Dropdown.Item>
                            );
                          })
                        ) : (
                          <li className="text-center">No Data Found</li>
                        )}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <button
                    id={`report_orientation_btn${theme}`}
                    style={{
                      color:
                        theme == "light" && layoutVal == "Portrait"
                          ? "white"
                          : "",
                      height: "33px",
                    }}
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Portrait"
                    onClick={() => {
                      setLayoutVal("Portrait");
                    }}
                    type="button"
                    className={
                      layoutVal == "Portrait"
                        ? "btn text-white border btn-sm active d-flex align-items-center"
                        : "btn border btn-sm d-flex align-items-center"
                    }
                  >
                    <IoDocumentOutline />
                  </button>
                  <button
                    id={`report_orientation_btn${theme}`}
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Landscape"
                    onClick={() => {
                      setLayoutVal("Landscape");
                    }}
                    style={{
                      color:
                        theme == "light" && layoutVal == "Landscape"
                          ? "white"
                          : "",
                      height: "33px",
                      marginRight: "0px",
                    }}
                    type="button"
                    className={
                      layoutVal == "Landscape"
                        ? " btn border btn-sm active d-flex align-items-center"
                        : "btn border btn-sm d-flex align-items-center"
                    }
                  >
                    <IoDocumentOutline
                      style={{ transform: "rotate(270deg)" }}
                    />
                  </button>
                  <Dropdown className="mr-auto transaction_dropdown">
                    <Dropdown.Toggle
                      disabled={laodingPdf}
                      id="report_dropdown"
                      style={{
                        background: "none",
                        padding: "0px",
                        margin: "0px",
                      }}
                    >
                      <div
                        id={`report_paperSize_${theme}`}
                        style={{
                          cursor: "pointer",
                          width: screen <= 500 ? "" : "fit-content",
                          borderTopLeftRadius: "0px",
                          borderBottomLeftRadius: "0px",
                          borderTopRightRadius: "5px",
                          borderBottomRightRadius: "5px",
                          color: theme == "dark" ? "white" : "black",
                        }}
                        className={
                          theme == "light"
                            ? "theme_light_border d-flex px-3 border py-1 align-items-center"
                            : "d-flex px-3 border py-1 align-items-center"
                        }
                      >
                        <IoPrintOutline />
                        <IoIosArrowDown
                          style={{
                            width: "15px",
                            height: "15px",
                          }}
                        />
                      </div>
                    </Dropdown.Toggle>

                    <Dropdown.Menu
                      id="dropDownPET"
                      style={{
                        maxHeight: "300px",
                        // minHeight: "300px",
                        overflow: "auto",
                        backgroundColor:
                          theme == "dark" ? "rgb(30, 30, 47)" : "",
                      }}
                    >
                      <Dropdown.Item
                        style={{ cursor: "pointer" }}
                        onClick={(e) => {
                          if (trialBalance && trialBalance?.length > 0) {
                            setLaodingPdf(true);
                            setlevelCheck({
                              simple_rows: true,
                              sub_rows: true,
                              sub_sub_rows: true,
                              sub_sub_sub_rows: true,
                            });
                            setExpandAll(true);
                            setCount(count + 1);
                            setTimeout(() => {
                              console.log("lets print", typeof printpdf);

                              if (typeof printpdf === "function") printpdf();
                              setLaodingPdf(false);
                            }, 3000);
                          } else {
                            setLaodingPdf(true);
                            console.log("lets print", typeof printpdf);
                            if (typeof printpdf === "function") printpdf();
                            setLaodingPdf(false);
                          }
                        }}
                      >
                        Print
                      </Dropdown.Item>
                      <Dropdown.Item
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          if (selectedValues?.columns?.length > 0) {
                            if (trialBalance && trialBalance?.length > 0) {
                              setLaodingPdf(true);
                              setlevelCheck({
                                simple_rows: true,
                                sub_rows: true,
                                sub_sub_rows: true,
                                sub_sub_sub_rows: true,
                              });
                              setExpandAll(true);
                              setCount(count + 1);
                              setTimeout(() => {
                                printExcel();
                                setLaodingPdf(false);
                              }, 3000);
                            } else {
                              setLaodingPdf(true);
                              printExcel();
                              setLaodingPdf(false);
                            }
                          } else {
                            toast.error("First select columns");
                          }
                        }}
                      >
                        Excel
                      </Dropdown.Item>
                      <Dropdown.Item
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          if (selectedValues?.columns?.length > 0) {
                            if (trialBalance && trialBalance?.length > 0) {
                              setLaodingPdf(true);
                              setlevelCheck({
                                simple_rows: true,
                                sub_rows: true,
                                sub_sub_rows: true,
                                sub_sub_sub_rows: true,
                              });
                              setExpandAll(true);
                              setCount(count + 1);
                              setTimeout(() => {
                                printTXT();
                                setLaodingPdf(false);
                              }, 3000);
                            } else {
                              setLaodingPdf(true);
                              printTXT();
                              setLaodingPdf(false);
                            }
                          } else {
                            toast.error("First select columns");
                          }
                        }}
                      >
                        text
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                  {/* <button
                                        id={`report_orientation_btn${theme}`}
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        disabled={laodingPdf ? true : false}
                                        title="Print"
                                        onClick={(e) => {
                                            if (count && trialBalance && trialBalance?.length > 0) {
                                                setLaodingPdf(true)
                                                setlevelCheck({
                                                    simple_rows: true,
                                                    sub_rows: true,
                                                    sub_sub_rows: true,
                                                    sub_sub_sub_rows: true,
                                                });
                                                setExpandAll(true);
                                                setCount(count + 1);
                                                setTimeout(() => {
                                                    const element = contentRef.current;
                                                    const options = {
                                                        filename: fileName,
                                                        margin: [10, 3, 10, 3],
                                                        image: { type: 'jpeg', quality: 0.95 },
                                                        html2canvas: { scale: 1 },
                                                        jsPDF: { unit: 'mm', format: paperSizeVal || "A4", orientation: layoutVal === "Landscape" ? 'landscape' : "portrait" },
                                                        pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
                                                    };
                                                    html2pdf()
                                                        .from(element)
                                                        .set(options)
                                                        .save();
                                                    setLaodingPdf(false)
                                                }, 3000);
                                            }
                                            else {
                                                setLaodingPdf(true)
                                                const element = contentRef.current;
                                                const options = {
                                                    filename: fileName,
                                                    margin: [10, 3, 10, 3],
                                                    image: { type: 'jpeg', quality: 0.95 },
                                                    html2canvas: { scale: 1 },
                                                    jsPDF: { unit: 'mm', format: paperSizeVal || "A4", orientation: layoutVal === "Landscape" ? 'landscape' : "portrait" },
                                                    pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
                                                };
                                                html2pdf()
                                                    .from(element)
                                                    .set(options)
                                                    .save();
                                                setLaodingPdf(false)
                                            }

                                        }}
                                        style={{
                                            // color: theme == "dark" ? "white" : "black",
                                            height: "33px"
                                        }}
                                        type="button"
                                        className={`btn border btn-sm d-flex align-items-center ${screen <= 500 ? "col-4" : ""}`}
                                    >
                                        <IoPrintOutline />

                                    </button> */}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* --------------- second row header starts from here ------------------------------- */}
      </div>
    </Col>
  );
};
export default ReportTemplates;
